module.exports = __webpack_public_path__ + "img/phone.163bfa53.png";